import { AutogenLayoutFreightMatchingProfile } from "./autogen/AutogenLayoutFreightMatchingProfile";
import { FreightMatchingUtil } from "./FreightMatchingUtil";

export class FreightMatchingProfile extends AutogenLayoutFreightMatchingProfile {

    onLoad(): void | Promise<void> {
        new FreightMatchingUtil(this);
    }
}